import * as Auth from './endpoints/Auth';
import * as Config from './endpoints/Config';
import * as User from './endpoints/User';
import * as Order from './endpoints/Order';
import * as Common from './endpoints/Common';
import * as Accounting from './endpoints/Accounting';
import * as Statistics from './endpoints/Statistics';
import * as Inquiry from './endpoints/Inquiry';
import * as OrderSupport from './endpoints/OrderSupport';
import * as SearchWord from './endpoints/SearchWord';
import * as Ledger from './endpoints/Ledger';
export default {
  config: Config,
  auth: Auth,
  user: User,
  order: Order,
  common: Common,
  accounting: Accounting,
  statistics: Statistics,
  Inquiry: Inquiry,
  orderSupport: OrderSupport,
  searchWord: SearchWord,
  ledger: Ledger,
};
